// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FPk4H","recommendations":"styles_recommendations__NS8wU","subtitle":"styles_subtitle___4au2","title":"styles_title__eu3pU","button":"styles_button__srwDy"};